var app = angular.module('leonardo');

var NgDialogConfig = function (ngDialogProvider) {
  ngDialogProvider.setDefaults({
    preCloseCallback: function (value) {
      return true;
    }
  });
};

app.config(['ngDialogProvider', NgDialogConfig]);
